import React from "react"
import { graphql } from "gatsby"
import Layout from "gatsby-theme-cactus/src/gatsby-theme-blank/components/Layout/layout"
import SEO from "gatsby-theme-blank/src/components/seo"
import NonStretchedImage from "gatsby-theme-blank/src/components/Image/non-stretched-image"
import AdditionalInformation from "gatsby-theme-blank/src/components/additional-information"
import {
  pageActu,
  pageActuAdditionalInfos,
  actualite,
  actualiteImg,
  actualiteTags,
  actualiteTaxo,
  actualiteTitle,
  actualiteContentFooter,
  actualiteContentFooterBack,
  actualiteContentFooterRight,
  actualiteContentFooterDate,
  socialPanelContainer,
} from "./styles/detailsActu.module.scss"
import ContentTransformer from "gatsby-theme-blank/src/components/Transformers/content-transformer"
import PropTypes from "prop-types"
import Ariane from "gatsby-theme-blank/src/components/Ariane/ariane"
import { useBuildData } from "gatsby-theme-blank/src/hooks/use-build-data"
import {
  ActuAdditionalInfos,
  ActualiteTags,
  ActuFooterBack,
  ActuFooterDate,
  ActualiteTitle,
} from "./styled-components/actualite-styled"
import { coverSpeed } from "gatsby-theme-lantana/src/gatsby-theme-cactus/gatsby-theme-blank/constants"
import AniLink from "gatsby-plugin-transition-link/AniLink"
import FadeIn from "react-fade-in"
import SocialPanel from "gatsby-theme-blank/src/components/SocialMedias/social-panel"
import TransitionFade from "gatsby-theme-blank/src/components/transition-fade"

//-----------------------Query Graphql---------------------------//

export const query = graphql`
  query($slug: String!) {
    nodeActualites(path: { alias: { eq: $slug } }) {
      ...ActualiteItem
    }
  }
`

//-----------------------Query Graphql---------------------------//

//-----------------------Parent component---------------------------//

const ActualiteTemplate = ({ data, location }) => {
  const buildColors = useBuildData().theme_settings.palette
  const nodeActualites = data.nodeActualites
  const allTaxos = nodeActualites.relationships.field_taxonomie_thematique
    .map((taxo) => {
      return taxo.name
    })
    .join()
  return (
    <Layout>
      <SEO
        title={nodeActualites.title}
        description={
          "Dans cette page, vous découvrez l'actualité suivante : " +
          nodeActualites.title +
          ", mais aussi l'ensemble des thématiques suivantes : " +
          allTaxos
        }
      />
      <FadeIn delay={250}>
        <Ariane
          pageNameLink="/actualites"
          pageName="Toutes les actualités"
          isDetail={true}
          postName={nodeActualites.title}
        />
        <section className={pageActu}>
          <ActualiteContent colors={buildColors} actu={nodeActualites} />
          <ActualiteContentFooter
            location={location.href}
            actu={nodeActualites}
          />
        </section>
        <ActualiteInfos actu={nodeActualites} />
      </FadeIn>
    </Layout>
  )
}
//-----------------------Parent component---------------------------//

//-----------------------Child component/Content---------------------------//

const ActualiteContent = ({ actu, colors }) => (
  <article className={actualite}>
    <div className={actualiteImg}>
      {actu.relationships?.field_image_actus?.localFile && (
        <NonStretchedImage
          alt={actu.field_image_actus.alt}
          {...actu.relationships.field_image_actus.localFile}
        />
      )}
    </div>
    {actu.relationships.field_taxonomie_thematique && (
      <ActualiteTags className={actualiteTags}>
        {actu.relationships.field_taxonomie_thematique.map((taxo) => (
          <span key={taxo.name} className={actualiteTaxo}>
            <AniLink
              cover
              direction="down"
              bg={colors.b_color_gradients.b_dark}
              duration={coverSpeed}
              to={taxo.path.alias}
            >
              {taxo.name}
            </AniLink>
          </span>
        ))}
      </ActualiteTags>
    )}
    <ActualiteTitle className={actualiteTitle}>{actu.title}</ActualiteTitle>
    {actu.body && <ContentTransformer content={actu.body.processed} />}
  </article>
)
//-----------------------Child component/Content---------------------------//

//-----------------------Child component/Content Footer---------------------------//

const ActualiteContentFooter = ({ actu, location }) => (
  <>
    <div className={actualiteContentFooter}>
      <ActuFooterBack className={actualiteContentFooterBack}>
        <TransitionFade
          arialabel="Retour à la liste des actualités"
          link="/actualites"
        >
          Retour à la liste des actualités
        </TransitionFade>
      </ActuFooterBack>
      <div className={actualiteContentFooterRight}>
        <ActuFooterDate className={actualiteContentFooterDate}>
          {actu.created}
        </ActuFooterDate>
      </div>
    </div>
    <div className={socialPanelContainer}>
      <SocialPanel location={location} postData={actu} />
    </div>
  </>
)
//-----------------------Child component/Content Footer---------------------------//

//-----------------------Child component/Infos---------------------------//
const ActualiteInfos = ({ actu }) => (
  <>
    {actu.field_infos_complementaires && (
      <ActuAdditionalInfos className={pageActuAdditionalInfos}>
        <AdditionalInformation node={actu} />
      </ActuAdditionalInfos>
    )}
  </>
)
//-----------------------Child component/Infos---------------------------//

//-----------------------Prop-Types---------------------------//
ActualiteTemplate.propTypes = {
  data: PropTypes.object.isRequired,
  location: PropTypes.object,
}
ActualiteContent.propTypes = {
  actu: PropTypes.object.isRequired,
  colors: PropTypes.object,
}
ActualiteInfos.propTypes = {
  actu: PropTypes.object.isRequired,
}
ActualiteContentFooter.propTypes = {
  actu: PropTypes.object.isRequired,
  location: PropTypes.object,
}
//-----------------------Prop-Types---------------------------//

export default ActualiteTemplate
